<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>下单预警规则</span>
      </div>
      <el-form ref="formRules" :model="formParams" label-width="130px">
        <el-form-item label="启用预警" prop="open_status">
          <el-switch v-model="formParams.open_status" active-color="#13ce66" inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
        <el-form-item label="预警基准值" prop="material_name">
          最近
          <el-input type="text" v-model="formParams.time_slot"></el-input>
          分钟，超过
          <el-input type="text" v-model="formParams.order_num"></el-input>单预警提醒
        </el-form-item>
        <el-form-item label="提醒手机号" prop="material_name">
          <div v-for="(item, index) in formParams.send_mobile" :key="'phone' + index">
            <el-input type="text" v-model="formParams.send_mobile[index]"></el-input>
            <el-button type="text" @click="delPhone(index)">删除</el-button>
          </div>
          <el-button type="primary" size="mini" @click="addPhone">添加手机号</el-button>
        </el-form-item>
        <el-form-item label="提醒邮箱" prop="material_name">
          <div v-for="(item, index) in formParams.send_email" :key="'phone' + index">
            <el-input type="text" v-model="formParams.send_email[index]"></el-input>
            <el-button type="text" @click="delEmail(index)">删除</el-button>
          </div>
          <el-button type="primary" size="mini" @click="addEmail">添加邮箱</el-button>
        </el-form-item>
        <!-- 保存设置 -->
        <div class="btn-box">
          <el-button type="primary" @click="save">保存设置</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import { getSecureSpuOrderSetting, setSecureSpuOrderSetting } from './api'


export default {
  components: {
  },
  data() {
    return {
      rules: [],
      formParams: {
        open_status: false,
        time_slot: '',
        order_num: '',
        send_mobile: [''],
        send_email: ['']
      },
    }
  },
  props: {
  },
  watch: {
  },
  mounted() {
    this.secureSpuOrderSetting()
  },
  methods: {
    secureSpuOrderSetting() {
      getSecureSpuOrderSetting().then(res => {
        this.formParams = res.data.data
        console.log("🚢 ~ 当前打印的内容 ~ res:", res);

      })
    },
    // 
    // 添加手机号
    addPhone() {
      this.formParams.send_mobile.push('')
    },
    // 删除手机号
    delPhone(index) {
      this.formParams.send_mobile.splice(index, 1)
    },
    // 添加邮箱
    addEmail() {
      this.formParams.send_email.push('')
    },
    // 删除邮箱
    delEmail(index) {
      this.formParams.send_email.splice(index, 1)
    },
    // 保存
    save() {
      setSecureSpuOrderSetting(this.formParams).then(res => {
        const { status } = res.data.data
        if (status) {
          this.$message({
            message: '保存成功',
            type: 'success'
          });
        }
      })
    }
  }
}

</script>

<style scoped lang="scss">
.el-form {
  .el-form-item {
    width: 800px;

    .el-input {
      width: 30%;
    }
  }
}

.btn-box {
  display: flex;
  justify-content: center;
}
</style>
